import React, { Component } from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { isIE } from './utils';

const defaultProps = {
    isOpen: false,
    tag: 'div'
};

class BbCollapse extends Component {
    constructor(props) {
        super(props);

        ['onExit', 'onExiting', 'onEntering', 'onEntered', 'renderIeVersion', 'renderInteractive'].forEach((name) => {
            this[name] = this[name].bind(this);
        });

        this.state = {
            height: props.isOpen ? null : 0
        }
    }

    onEntering(node) { this.setState({ height: node.scrollHeight }); }
    onEntered() { this.setState({ height: null }); }
    onExit(node) { this.setState({ height: node.scrollHeight }); }
    onExiting(node) {
        // getting this variable triggers a reflow
        const _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
        this.setState({ height: 0 });
    }

    render() {
        return isIE() ? this.renderIeVersion() : this.renderInteractive();
    }

    renderIeVersion(){
        const { tag: Tag, isOpen, className, children, style } = this.props;

        return (
            //timeout must be in sync with css transition duration
            <CSSTransition in={isOpen} timeout={0}>
                {(status) => <Tag className={classnames(className, 'bb-collapse', status)} style={style}>{children}</Tag>}
            </CSSTransition>
        );
    }

    renderInteractive(){
        const { tag: Tag, isOpen, className, children, style } = this.props;
        const hstyle = this.state.height === null ? null : { height:this.state.height };

        return (
            //timeout must be in sync with css transition duration
            <CSSTransition in={isOpen} timeout={300}
                onExit={this.onExit} onExiting={this.onExiting}
                onEntered={this.onEntered} onEntering={this.onEntering}>
                {(status) => <Tag className={classnames(className, 'bb-collapse', status)} style={{...style, ...hstyle}}>{children}</Tag>}
            </CSSTransition>
        );
    }
}

BbCollapse.defaultProps = defaultProps;

export default BbCollapse